export default class ExportRankOrderScatterPlotViewModel {
    exportType: "PDF" | "JPEG" = "PDF";
    addUserComments: boolean = false;
    userComment: string | null = null;
    displayToScreen: boolean = true;
    fileName: string = "";
    scatterPlotData: { x: number; y: number; label: string }[] = [];
    selectedRange: string = "";
    direction: string = "";
    vehicleType: string = "";
    calculationFactor: string = "";
    parameter: string = "";
    xAxisMin: number | null = null;
    xAxisMax: number | null = null;
    xAxisStepSize: number | null = null;
    yAxisMin: number | null = null;
    yAxisMax: number | null = null;
}
